module.exports = __webpack_public_path__ + "static/media/pluja.c647cb9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pluja.png
// module id = 112
// module chunks = 0